import app from '../app';
import Modal from '../../common/components/Modal';
import Button from '../../common/components/Button';
import Stream from '../../common/utils/Stream';
import AgreementModal from '../components/AgreementModal';

export default class RefundModal extends Modal {
  oninit(vnode) {
    super.oninit(vnode);
    this.checked = true
    this.balance = vnode.attrs.balance //余额
    this.sdkUserPc = ()=>{vnode.attrs.sdkUserPc()}
  }

  className() {
    return 'NickameModal Modal--small dl-modal-small refund-modal';
  }

  title() {
    return  this.checked?(
      <div className='modal-title'>{app.translator.trans('dl-pay.forum.operation.refund_from_wallet',{balance: this.balance})}</div>
    ):(
      <div className='modal-title'>{app.translator.trans('dl-pay.forum.operation.successfully_submitted_refund_request')}</div>
    )
  }

  content() {
    return this.checked?(
      this.confirmPopup()
    ):(
      this.Successpopup()
    )
  }
  confirmPopup(){
    let baseUrl = app.forum.attribute('baseUrl');
    let userLink = app.data.pkgLogo.userLink;
    let localeUserLink = '';
    if (userLink) {
      // 将字符串映射转换为 JavaScript 对象
      const obj = JSON.parse(userLink);
      // 创建 Map 对象并初始化
      const map = new Map(Object.entries(obj));
      // 获取特定键的值
      localeUserLink = map.get(app.data.locale);
    }
    return (
      <div className="refund-modal-box">
        <div className='modal-content'>{app.translator.trans('dl-pay.forum.operation.submit_application_after_text')}
        <a href={localeUserLink
            ?  localeUserLink.includes('http')
              ? localeUserLink
              : baseUrl + localeUserLink
            : '#'}>
              {/* <u onclick={() => app.modal.show(AgreementModal, { data: userAgreement, title: app.translator.trans('dl-pay.forum.comfirm.user_agreement_text') }, true)}> */}
                {app.translator.trans('dl-pay.forum.comfirm.user_agreement')}
              {/* </u> */}
            </a>
        </div>
        <div className='btn-box'>
          <div className='confirm btn' onclick={()=>{
            // 发送退款接口
            app.request({
              method: 'GET',
              url: app.forum.attribute('apiUrl') + '/sdkUserPcRefund',
              params: {
                money: this.balance,
              }
            })
            this.checked = false
          }}>{app.translator.trans('dl-pay.forum.operation.sure')}</div>
          <div className='cancel btn' onclick={()=>{this.hide()}}>{app.translator.trans('dl-pay.forum.operation.cancel')}</div>
        </div>
      </div>
    )
  }
  Successpopup(){
    return (
      <div className="refund-modal-box">
        <div className='modal-content'>{app.translator.trans('dl-pay.forum.operation.after_successful_review')}</div>
        <div className='btn-box'>
          <div className='confirm btn' onclick={()=>{this.hide(); this.sdkUserPc() }}>{app.translator.trans('dl-pay.forum.operation.sure')}</div>
        </div>
      </div>
    )
  }
}
